<app-topbar class="topbar"></app-topbar>
<div class="content-app">
  <app-sidebar class="sidebar"></app-sidebar>
  <main>
    <router-outlet></router-outlet>
    <!-- <footer class="footer">Footer content</footer> -->
  </main>
</div>
